import React, { useEffect, useState } from 'react';
import { ReactComponent as CloseIcon } from '../../../../../assets/svg/shared/icon-close.svg';

interface IWidgetModalProps {
  children: React.ReactNode;
  onClose: () => void;
}

const STYLES = {
  CONTAINER:
    'w-full h-[220px] bg-bw00 absolute bottom-0 left-0 rounded-[12px] pt-[32px] pb-[14px] px-[20px] transition-all duration-500 ease-out transform ',
};
export const WidgetModal = ({ children, onClose }: IWidgetModalProps) => {
  const [showCard, setShowCard] = useState<boolean>(false);
  const handleOnCloseClick = () => {
    setShowCard(false);
    setTimeout(() => {
      onClose();
    }, 500);
  };
  useEffect(() => {
    setShowCard(true);
  }, []);
  return (
    <div className='w-full h-full bg-[#000] bg-opacity-30 rounded-[14px] absolute top-0 left-0 z-[100]'>
      <div className={`${STYLES.CONTAINER} ${showCard ? ' -translate-y-0' : 'translate-y-full'}`}>
        <CloseIcon
          className='w-[24px] h-[24px] fill-bw07 hover:bg-bw02 absolute top-[10px] right-[10px] cursor-pointer  rounded-full'
          onClick={handleOnCloseClick}
        />
        {children}
      </div>
    </div>
  );
};
